var _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _g2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDataFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 165,
    viewBox: "0 0 169 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.2076 144.684C126.161 144.684 158.55 112.296 158.55 72.3422C158.55 32.3887 126.161 0 86.2076 0C46.2542 0 13.8655 32.3887 13.8655 72.3422C13.8655 112.296 46.2542 144.684 86.2076 144.684Z",
    fill: "url(#paint0_linear_3434_457062)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3434_457062)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.4338,
    y: 20.8325,
    width: 75.0773,
    height: 93.4594,
    rx: 16,
    fill: "url(#paint1_linear_3434_457062)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56.0652,
    y: 32.8896,
    width: 50,
    height: 1,
    rx: 0.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.0652,
    y: 51.8896,
    width: 60.2851,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.0652,
    y: 70.8896,
    width: 60.2851,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56.0652,
    y: 89.8896,
    width: 60.2851,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56.0652,
    y: 108.89,
    width: 60.2851,
    height: 1,
    rx: 0.5,
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.374 118.499C115.138 118.499 122.354 116.15 128.35 112.124L152.886 135.546L161.784 125.222L138.108 102.621C142.481 96.4673 145.052 88.944 145.052 80.8203C145.052 60.0112 128.183 43.1421 107.374 43.1421C86.5644 43.1421 69.6953 60.0112 69.6953 80.8203C69.6953 101.629 86.5644 118.499 107.374 118.499ZM139.511 80.8203C139.511 98.4375 125.229 112.719 107.612 112.719C89.9949 112.719 75.7133 98.4375 75.7133 80.8203C75.7133 63.2031 89.9949 48.9215 107.612 48.9215C125.229 48.9215 139.511 63.2031 139.511 80.8203Z",
    fill: "#DEEDFD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_3434_457062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.609 113.336C125.755 113.336 140.464 98.7611 140.464 80.782C140.464 62.8029 125.755 48.228 107.609 48.228C89.4635 48.228 74.7537 62.8029 74.7537 80.782C74.7537 98.7611 89.4635 113.336 107.609 113.336Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.29 80.7822L121.241 72.862C121.986 72.0785 122.394 71.0371 122.378 69.9593C122.363 68.8814 121.925 67.852 121.159 67.0897C120.392 66.3275 119.356 65.8925 118.271 65.8772C117.187 65.862 116.139 66.2676 115.351 67.008L107.382 74.9282L99.4312 67.008C99.0486 66.6055 98.5887 66.2834 98.0787 66.0607C97.5686 65.838 97.0188 65.7192 96.4618 65.7114C95.9048 65.7035 95.3518 65.8068 94.8357 66.015C94.3195 66.2233 93.8506 66.5323 93.4567 66.9238C93.0627 67.3154 92.7518 67.7814 92.5423 68.2944C92.3327 68.8075 92.2289 69.3571 92.2367 69.9107C92.2446 70.4643 92.3642 71.0108 92.5882 71.5177C92.8123 72.0246 93.1364 72.4817 93.5413 72.862L101.506 80.7822L93.5413 88.7024C93.1364 89.0827 92.8123 89.5398 92.5882 90.0467C92.3642 90.5537 92.2446 91.1001 92.2367 91.6537C92.2289 92.2074 92.3327 92.757 92.5423 93.27C92.7518 93.783 93.0627 94.2491 93.4567 94.6406C93.8506 95.0321 94.3195 95.3411 94.8357 95.5494C95.3518 95.7577 95.9048 95.8609 96.4618 95.8531C97.0188 95.8452 97.5686 95.7265 98.0787 95.5037C98.5887 95.281 99.0486 94.9589 99.4312 94.5565L107.4 86.6363L115.369 94.5565C116.164 95.2532 117.198 95.622 118.258 95.5879C119.317 95.5537 120.324 95.1191 121.073 94.3727C121.822 93.6263 122.256 92.6241 122.287 91.5706C122.318 90.517 121.944 89.4913 121.241 88.7024L113.29 80.7822Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.884 135.547L161.782 125.223L163.122 126.502C164.423 127.744 165.201 129.478 165.287 131.323C165.372 133.169 164.758 134.974 163.578 136.343C162.399 137.711 160.751 138.531 158.997 138.621C157.244 138.711 155.528 138.064 154.228 136.822L152.887 135.543L152.884 135.547Z",
    fill: "#DEEDFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7293 37.4802C29.7179 36.6206 29.6101 35.7535 29.3944 34.8804C28.638 31.8167 25.2633 29.8498 21.6715 29.3873C18.0811 28.9249 14.3474 29.9773 12.9084 32.6423C12.0854 34.166 11.9718 35.4793 12.3082 36.5865C12.6431 37.6877 13.4377 38.6008 14.5163 39.3122C17.5234 41.294 22.7898 41.6986 25.1924 40.8701C26.3035 40.4862 27.3891 40.0237 28.4464 39.4946C27.8418 42.9585 25.5897 46.2401 22.584 49.1972C16.0518 55.624 5.91499 60.502 0.394604 62.2955C0.0980072 62.3918 -0.0666249 62.7209 0.0256181 63.0306C0.117861 63.3404 0.432901 63.5139 0.729497 63.4175C6.35915 61.5885 16.6932 56.6067 23.3546 50.0524C26.796 46.667 29.2482 42.8562 29.6668 38.8498C37.4465 34.5084 43.8354 26.6319 49.2976 20.0035C49.5005 19.7589 49.4735 19.3869 49.238 19.1749C49.0024 18.9644 48.6476 18.9911 48.4446 19.2371C43.2052 25.5944 37.1243 33.1566 29.7293 37.4802ZM28.5983 38.1102C28.6408 37.1438 28.55 36.1625 28.3045 35.1724C27.6503 32.5207 24.6431 30.9526 21.5338 30.5524C19.628 30.3078 17.6682 30.5094 16.1313 31.2268C15.1648 31.6774 14.3687 32.331 13.889 33.2204C13.2589 34.3869 13.1227 35.3844 13.381 36.2307C13.6392 37.083 14.2807 37.7678 15.1166 38.3177C17.8569 40.1245 22.6521 40.5084 24.839 39.754C26.129 39.3093 27.3807 38.7549 28.5983 38.1102Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3434_457062",
    x: 19.4338,
    y: 10.8325,
    width: 135.077,
    height: 153.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3434_457062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3434_457062",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_3434_457062",
    x: 66.7537,
    y: 40.228,
    width: 81.7107,
    height: 81.1079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3434_457062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3434_457062",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3434_457062",
    x1: 85.65,
    y1: -23.5564,
    x2: 87.1319,
    y2: 230.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3434_457062",
    x1: 86.9725,
    y1: 20.8325,
    x2: 86.9725,
    y2: 114.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FAFAFA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/noDataFound.383258af63b7dd725b4db49f12499fee.svg";
export { ForwardRef as ReactComponent };